import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";

const useStyles = makeStyles((theme: any) => ({
  root: { display: "flex", alignItems: "center" },
  icon: { marginRight: 8, color: theme.palette.status.draft },
  text: { fontSize: "1.3em" },
}));

export default function NoInfo() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <NotificationsActiveIcon className={classes.icon} />
      <p className={classes.text}>
        It looks like there was an issue getting your journey information.
      </p>
    </div>
  );
}
